import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
})
export class ConfirmationComponent implements OnInit {

  @Input() img:any;
  @Input() message: string;
  @Input() width: number = 288;
  @Input() top: number;
  @Input() right: number;
  @Output() doConfirme: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  cancel(){
    this.doConfirme.emit(false);
  }

  ok(){
    this.doConfirme.emit(true);
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/modules/confirmation/confirmation.component.ts